import { z } from 'zod';
import { BIOME_IDS } from './biomes.js';
/**
 * Chests of the world (ADR 0021). Data, not code: where a chest stands, what
 * kind it is, which biome fills it.
 *
 * - A **camp** chest stands in a monster camp, locked while any monster of
 *   the camp lives. Once the camp is cleared, every player who fought it may
 *   open it once; the camp comes back whole, and the chest locks again.
 * - A **hidden** chest rewards exploring: in a cave, on a summit, in a nook
 *   of the valley. Each character may open it once, then again four hours
 *   later.
 */
export const CHEST_KINDS = ['camp', 'hidden'];
export const ChestPlacementSchema = z.object({
    id: z.string().regex(/^[a-z0-9-]{1,32}$/),
    x: z.number().int().min(0),
    y: z.number().int().min(0),
    kind: z.enum(CHEST_KINDS),
    /** Whose pool fills it. */
    biome: z.enum(BIOME_IDS),
    /** The camp that keeps it locked (`MobSpawn.camp`), for a camp chest. */
    camp: z.string().min(1).max(32).optional(),
});
/** A hidden chest fills again this long after a character opened it: a find, not a farm. */
export const HIDDEN_CHEST_RESPAWN_MS = 4 * 60 * 60 * 1000;
/** A cleared camp comes back, every monster at once, this long after its last fell. */
export const CAMP_RESPAWN_MS = 10 * 60 * 1000;
/** A chest opens from any tile touching it, diagonals included. */
export const CHEST_REACH = 1;
//# sourceMappingURL=chests.js.map